import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router'
import { ResponsiveText } from 'components/ResponsiveComponents'
import { ButtonMenu, ButtonMenuItem, useMatchBreakpoints } from 'pancakeswap-uikit'
import { RouteComponentProps, Link } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'
import ImageContainer from 'views/Home/components/ImageContainer'
import Page from '../Page'
import Exchange from './Exchange'
import Liquidity from './Liquidity'
import BackgroundWrapper from './components/BackgroundWrapper'
import MobileBackgroundWrapper from './components/MobileBackgroundWrapper'
import Ellipse from '../../components/Svg/Ellipse'

const ContentContainer = styled.div<{ liquidityPage? }>`
  width: 100%;
  text-align: center;
  position: relative;
  margin-bottom: ${({ liquidityPage }) => (liquidityPage ? '250px' : '220px')};

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 500px;
    text-align: center;
    margin-left: -20%;
    position: relative;
    margin-bottom: 250px;
  }
`

const StyledLink = styled(Link)`
  font-family: Bebas Neue;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
`

export default function Swap(props: RouteComponentProps) {
  const { pathname } = useLocation()
  const index = pathname.includes('liquidity') ? 1 : 0
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()

  return (
    <Page>
      {!isMobile ? (
        <ImageContainer top="430px" left="0px">
          <Ellipse width="33" height="55" viewBox="0 0 33 55" cx="5.5" cy="27.5" r="25.5" />
        </ImageContainer>
      ) : (
        <ImageContainer bottom="0px" right="30%" zindex="-1">
          <Ellipse width="16" height="12" viewBox="0 0 16 12" cx="8" cy="8" r="6.89655" />
        </ImageContainer>
      )}

      <ContentContainer liquidityPage={index}>
        {!isMobile ? <BackgroundWrapper /> : <MobileBackgroundWrapper />}
        <ButtonMenu isMobile={isMobile} activeIndex={index} m={['24px 0 24px 0', null, '60px 0 40px 0']} p="11px 24px">
          <ButtonMenuItem>
            <StyledLink to="/exchange">Exchange</StyledLink>
          </ButtonMenuItem>
          <ButtonMenuItem p="11px 24px 11px 0">
            <StyledLink to="/liquidity">Liquidity</StyledLink>
          </ButtonMenuItem>
        </ButtonMenu>

        <ResponsiveText
          fontFamily="Bebas Neue"
          fontWeight="400"
          desktopFontSize="72px"
          mobileFontSize="40px"
          lineHeight="100%"
          textAlign="center"
          color="#1B1B1B"
        >
          {index ? t('Your liquidity') : t('Exchange')}
        </ResponsiveText>
        <ResponsiveText
          fontFamily="Lexend"
          fontWeight="200"
          desktopFontSize="18px"
          mobileFontSize="14px"
          lineHeight="22px"
          textAlign="center"
          color="#1b1b1b80"
          mb={['24px', null, '40px']}
        >
          {index ? t('Remove liquidity to receive tokens back') : t('Trade tokens in an instant')}
        </ResponsiveText>
        {index ? <Liquidity /> : <Exchange {...props} />}
      </ContentContainer>
    </Page>
  )
}
